import React from "react";
import { Controller } from "react-hook-form";
import { Checkbox } from "../../../../../../Inputs";
import { Text } from "../../../../../../Inputs/react-hook-form";
import type { PathArray } from "../../FieldPathContext/FieldPathContext";
import {
  getSchemaPropertyFormPath,
  getUiSchemaPropertyFormPath,
  useBuilderFormContext,
  useBuilderWatch,
} from "../../form";
import { FieldWrapper } from "../__styles__/SidebarColumn";
import { WidgetSettingsContainer } from "./__styles__/WidgetSettings";
import type { InputSettingsFormProps } from "./FieldSettingsView";
import { DefaultValuesSection } from "./shared/DefaultValuesSection";
import { FieldSettingsConfig } from "./shared/FieldSettingsConfig";

export function CheckboxWidgetSettings({
  fieldPath,
  isReadOnly,
  isModuleInput,
}: InputSettingsFormProps) {
  const { register, getFieldState } = useBuilderFormContext();
  const isFormulaField = !!useBuilderWatch(
    getSchemaPropertyFormPath(fieldPath, "formula"),
  );

  const checkboxTextPropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "checkboxText",
  );
  const checkboxTextFieldError = getFieldState(
    checkboxTextPropertyFormPath,
  )?.error;

  return (
    <WidgetSettingsContainer>
      <FieldSettingsConfig
        fieldPath={fieldPath}
        isModuleInput={isModuleInput}
        isFormulaField={isFormulaField}
        isLabelRequired={false}
        isReadOnly={isReadOnly}
      />
      <div>
        <Text
          {...register(checkboxTextPropertyFormPath, {
            required: "Checkbox text is required",
          })}
          label="Checkbox text"
          error={checkboxTextFieldError?.message}
          required
          disabled={isReadOnly}
        />
      </div>
      <DefaultValuesSection>
        <CheckboxDynamicDefaultInput
          fieldPath={fieldPath}
          isReadOnly={isReadOnly}
        />
      </DefaultValuesSection>
    </WidgetSettingsContainer>
  );
}

type CheckboxDynamicDefaultInputProps = {
  fieldPath: PathArray;
  isReadOnly?: boolean;
};

function CheckboxDynamicDefaultInput({
  fieldPath,
  isReadOnly = false,
}: CheckboxDynamicDefaultInputProps) {
  const { control } = useBuilderFormContext();
  const defaultValuePathPropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "defaultValuePath",
  );
  const defaultValuePath = useBuilderWatch(defaultValuePathPropertyFormPath);

  return (
    <FieldWrapper data-testid="dynamic-default-value-wrapper">
      <Controller
        control={control}
        name={defaultValuePathPropertyFormPath}
        render={({ field }) => {
          return (
            <Checkbox
              value={defaultValuePath === "boolean.true"}
              label={field.value === "boolean.true" ? "Checked" : "Unchecked"}
              disabled={isReadOnly}
              onChange={(value: boolean) =>
                field.onChange(value ? "boolean.true" : undefined)
              }
            />
          );
        }}
      />
    </FieldWrapper>
  );
}
